import { atom } from "recoil";

import { ROUTES } from "../../helpers/constants";

const loginAtom = atom({
  key: 'login',
  default: {
    signed: false,
    loading: false,
    updating: false
  }
});

const userAtom = atom({
  key: 'userData',
  default: {
    data: {
      id: 'card-1',
      displayName: '',
      name: '',
      family_name: '',
      email: '',
      phoroUrl: 'https://cdn-icons-png.flaticon.com/512/149/149071.png',
      role: 'Administrador',
      group: 'Singulares',
      phone_number: '',
      url: ROUTES.PROFILE.route,
      isSuperAdmin: false,
      isAdmin: false,
      isAdminBasic: false,
      clientId: "",
      // true mientras el usuario deba hacer el cambio de contraseña obligatorio
      mustChangePassword: false
    },
    loading: false
  }
});

export { loginAtom, userAtom };